import TextField from '@mui/material/TextField';
import MuiButton from '@mui/material/Button';
import { Box, styled } from '@mui/material';

import { colors, devices } from 'styles';

export const ContactFormWrapper = styled(Box)`
  color: ${colors.white};
  background: #348ee9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 80px 0;
`;

export const ThanksText = styled('p')`
  margin: 0 auto;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
`;

export const ContactFormText = styled('p')`
  line-height: 22px;
  font-weight: 700;
  line-height: 120%;
  margin-top: 0;
  width: 764px;
  text-align: center;
  font-size: 32px;
  width: 343px;
  margin: 0;

  @media (${devices.sm}) {
    font-size: 36px;
    width: 764px;
  }

  @media (${devices.lg}) {
    font-size: 48px;
  }
`;

export const ContactFormDescription = styled('p')`
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0px;
  text-align: center;
  width: 100%;
  max-width: 300px;
  color: rgba(255, 255, 255, 0.8);
  margin: 16px 0 0 0;

  @media (${devices.sm}) {
    max-width: 716px;
  }
`;

export const FormControlContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 0;
  position: relative;
  z-index: 2;

  @media (${devices.sm}) {
    align-items: center;
    flex-direction: row;
    /* flex-basis: 500px; */
  }

  @media (${devices.md}) {
  }
`;

export const EmailInputContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  background: ${colors.white};
  padding: 16px;
  margin: 0;
  border-radius: 4px;
  min-width: 343px;
  margin-bottom: 8px;
  margin-top: 36px;

  @media (${devices.sm}) {
    min-width: 500px;
    height: 68px;
    padding: 16px 6px 16px 16px;
  }
`;

export const EmailInput = styled(TextField)`
  border: 0;
  height: 24px;
  max-width: 280px;
  width: 100%;
  padding: 0;

  & fieldset {
    border: 0;
  }

  & input {
    padding: 0;
    color: #8b8e93;
  }
`;

export const Button = styled(MuiButton)`
  &.Mui-disabled {
    background: ${colors.mainGray} !important;
  }

  &.MuiButtonBase-root {
    box-sizing: border-box;
    background: ${colors.mainDark};
    color: ${colors.white};
    width: 100%;
    font-size: 16px;
    text-transform: none;
    line-height: 24px;
    font-weight: 700;
    padding: 16px;

    @media (${devices.sm}) {
      width: 184px;
    }
  }
`;

export const WebWrapper = styled(Box)`
  position: absolute;

  img {
    width: 100%;
    max-width: 300px;
    height: 100%;
    display: block;

    @media (${devices.sm}) {
      max-width: 400px;
    }
  }
`;
